import React from 'react';
import { ArrowRight, Award, Users, Building2 } from 'lucide-react';
import { Button } from './ui/button';
import { heroImage } from '../mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative pt-20">
      {/* Hero Content */}
      <div className="relative bg-gradient-to-br from-[#faf8f5] to-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6 py-20 lg:py-32">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              <div className="inline-block">
                <span className="px-4 py-2 bg-[#c9a961]/10 text-[#c9a961] rounded-full text-sm font-semibold">
                  Award-Winning Custom Home Builders
                </span>
              </div>
              
              <h1
                className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Crafting Bespoke{' '}
                <span className="text-[#c9a961]">Luxury Homes</span>{' '}
                in Sydney
              </h1>
              
              <p className="text-lg text-gray-600 leading-relaxed">
                With over 15 years of excellence in custom luxury home construction, renovations, extensions, and pool & deck installations, we transform your vision into architectural masterpieces. From new home builds and duplexes to stunning renovations and resort-style outdoor living spaces.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  onClick={() => scrollToSection('contact')}
                  size="lg"
                  className="bg-[#c9a961] hover:bg-[#b89851] text-white transition-colors group"
                >
                  Start Your Journey
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  onClick={() => scrollToSection('portfolio')}
                  size="lg"
                  variant="outline"
                  className="border-2 border-gray-300 hover:border-[#c9a961] hover:text-[#c9a961] transition-colors"
                >
                  View Portfolio
                </Button>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-6 pt-8 border-t border-gray-200">
                <div>
                  <div className="flex items-center gap-2 text-[#c9a961] mb-2">
                    <Award className="h-5 w-5" />
                  </div>
                  <div className="text-3xl font-bold text-gray-900">15+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div>
                  <div className="flex items-center gap-2 text-[#c9a961] mb-2">
                    <Users className="h-5 w-5" />
                  </div>
                  <div className="text-3xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Client Satisfaction</div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={heroImage}
                  alt="Luxury Home by My Home Experts"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              
              {/* Floating Card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                <div className="flex items-start gap-4">
                  <div className="h-12 w-12 bg-[#c9a961]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Building2 className="h-6 w-6 text-[#c9a961]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">5-Stage Process</h3>
                    <p className="text-sm text-gray-600">Transparent project management with automated progress tracking</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;